"use client";

import GlobalErrorPage from "@packages/components/GlobalErrorPage";

export default GlobalErrorPage;
